import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { tripColumnDef } from '../constant';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useLoadTripDetails } from '../../../hook/useLoadTripDetails';
import { focusElemnt, useDebouncedHandler } from '../../../utils/helpers';
import ContainsFilter from '../../../common/ContainsFilter';
const TripTable = (props) => {
    const { tableData = [], setBkgDetails, setFilterOpt,
        handleResetTripData = () => { },
        setSelectedSeat,
        bkgDeatails,
    } = props;
    const { loadTripDetails } = useLoadTripDetails();
    const [sortConfig, setSortConfig] = useState({
        field: null,
        direction: null,
    });
    const [searchFilter, setSearchFilter] = useState({})
    const [tableHeight, setTableHeight] = useState(
        () => localStorage.getItem('tripTableHeightV2') || '200px'
    );
    const containerRef = useRef(null);
    useEffect(() => {
        setSearchFilter({})
    }, [tableData])
    useEffect(() => {
        const handleMouseUp = () => {
            if (containerRef.current) {
                const height = `${containerRef.current.offsetHeight}px`;
                setTableHeight(height);
                localStorage.setItem('tripTableHeightV2', height);
            }
        };
        window.addEventListener('mouseup', handleMouseUp);
        return () => {
            window.removeEventListener('mouseup', handleMouseUp);
        };
    }, []);
    const filteredData = useMemo(() => {
        // 🔹 Filtering
        let data = tableData.filter((row) =>
            Object.entries(searchFilter).every(([field, value]) => {
                if (!value) return true;
                const cellValue = String(row[field] ?? "").toLowerCase();
                return cellValue.includes(value.toLowerCase());
            })
        );

        if (sortConfig.field && sortConfig.direction) {
            const { field, direction } = sortConfig;

            data = [...data].sort((a, b) => {
                let valA = a[field];
                let valB = b[field];

                if (valA === null || valA === undefined) valA = "";
                if (valB === null || valB === undefined) valB = "";

                const isNumber = (v) => !isNaN(parseFloat(v)) && isFinite(v);

                if (isNumber(valA) && isNumber(valB)) {
                    valA = Number(valA);
                    valB = Number(valB);
                } else {
                    valA = String(valA).trim().toLowerCase();
                    valB = String(valB).trim().toLowerCase();
                }

                if (valA < valB) return direction === "asc" ? -1 : 1;
                if (valA > valB) return direction === "asc" ? 1 : -1;
                return 0;
            });
        }

        return data;
    }, [tableData, sortConfig, searchFilter]);

    const handleSortClick = (field) => {
        setSortConfig((prev) => {
            if (prev.field === field) {
                const newDirection = prev.direction === "asc" ? "desc" : "asc";
                return { field: field, direction: newDirection };
            } else {
                return { field: field, direction: "asc" };
            }
        });
    }

    const handleTrip = (trip) => {
        handleResetTripData()
        loadTripDetails({ tripDetails: trip, setBkgDetails, setFilterOpt, setSelectedSeat });
    }



    const handleFilterData = (field, value) => {
        setSearchFilter((prev) => ({ ...prev, [field]: value }));
    };

    const handleFilterDataDebounced = useDebouncedHandler(handleFilterData, 400);
    return (
        <Box className='tripTable'>
            <TableContainer ref={containerRef}
                component={Paper} className='scrollBlueV8' sx={{
                    boxShadow: 'none !important',
                    height: tableHeight,
                    width: '100%',
                    minHeight: '10px',
                    maxHeight: '400px',
                    resize: 'vertical',
                }}>
                <Table stickyHeader size="small" aria-label="a dense table"
                    sx={{
                        '& .MuiTableCell-root': {
                            padding: '8px 6px',
                            borderBottom: '1px solid #0000001A',
                            fontFamily: 'Roboto',
                        },
                        '& .MuiTableCell-root:first-of-type': {
                            paddingLeft: '12px',
                        },
                        '& .MuiTableCell-root:last-of-type': {
                            paddingRight: '12px',
                        },
                    }}
                >
                    <TableHead>
                        <TableRow>
                            {tripColumnDef.map((col) => (
                                <TableCell
                                    sx={{
                                        ...col.headerSx,
                                        backgroundColor: '#E5F3FF',
                                        fontFamily: 'Roboto',
                                        fontWeight: 600,
                                        fontStyle: 'Medium',
                                        fontSize: '12px',
                                        lineHeight: '16px',
                                        letterSpacing: '2%',
                                        color: '#444444',
                                        verticalAlign: 'middle',
                                        cursor: 'pointer',

                                    }}>
                                    <Box sx={{
                                        display: 'flex', alignItems: 'center',
                                        justifyContent: col.headerSx.textAlign === 'right' ? 'end' : 'start'

                                    }}
                                        onClick={() => {
                                            if (col.isSorted) {
                                                handleSortClick(col.field)
                                            }
                                        }}
                                    >
                                        <span>{col.headerName}</span>
                                        {col.isSorted ?
                                            sortConfig.field === col.field && sortConfig.direction === 'asc' ?
                                                <ArrowDropDownIcon sx={{ fontSize: '16px' }} />
                                                :
                                                <ArrowDropDownIcon sx={{ transform: 'rotate(180deg)', fontSize: '16px' }} />
                                            : ''
                                        }
                                    </Box>
                                </TableCell>
                            ))}
                        </TableRow>
                        <TableRow>
                            {tripColumnDef.map((col, index) => (
                                <TableCell>
                                    <ContainsFilter value={searchFilter?.[col?.field]} onChange={(event) => {
                                        handleFilterDataDebounced(col?.field, event.target.value)
                                    }}
                                        onKeyDown={(event) => {
                                            if (event.key === 'Enter' && filteredData.length !== 0) {
                                                focusElemnt(`trip-0`)
                                            }
                                        }}
                                    />
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody
                        sx={{
                            '& .MuiTableRow-root': {
                                transition: 'background-color 0.2s ease',
                            },
                            '& .MuiTableRow-root:hover': {
                                backgroundColor: '#F5F9FF',
                            },
                            '& .MuiTableCell-root': {
                                fontWeight: '500',
                                fontStyle: 'Medium',
                                fontSize: '12px',
                                letterSpacing: '2%',
                                color: '#555555',
                                fontFamily: 'Roboto !important',
                            }
                        }}

                    >
                        {filteredData.map((obj, index) => (
                            <TableRow
                                key={obj?.TripID || Math.random()}
                                id={`trip-${index}`}
                                title={obj?.CompanyName || ''}
                                hover
                                tabIndex={0}
                                className={`tripDataRow ${Object.keys(bkgDeatails.tripDetails).length !== 0 && (obj.TripID === bkgDeatails.tripDetails.TripID && obj.TripTime === bkgDeatails.tripDetails.TripTime) ? 'selectRow' : ''}`}
                                onClick={() => handleTrip(obj)}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' && (obj.TripID === bkgDeatails.tripDetails.TripID && obj.TripTime === bkgDeatails.tripDetails.TripTime)) {
                                        focusElemnt('phoneNumber')
                                    } else if (event.key === 'Enter') {
                                        handleTrip(obj)
                                    } else if (event.key === 'ArrowDown') {
                                        event.preventDefault();
                                        focusElemnt((tableData?.length - 1) === index ? `trip-0` : `trip-${index + 1}`)
                                    } else if (event.key === 'ArrowUp') {
                                        event.preventDefault();
                                        focusElemnt(index === 0 ? `trip-${tableData?.length - 1}` : `trip-${index - 1}`)
                                    } else if (event.key === 'Escape') {
                                        event.preventDefault();
                                        focusElemnt('search_btn')
                                    }
                                }}

                            >
                                {tripColumnDef.map((col) => (
                                    <TableCell

                                        sx={{
                                            ...col.headerSx,
                                            fontFamily: 'Roboto !important',
                                            fontWeight: 500,
                                            fontStyle: 'Medium',
                                            fontSize: '12px',
                                            lineHeight: '16px',
                                            letterSpacing: '2%',
                                            color: '#555555',
                                            cursor: 'pointer',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            maxWidth: 0,

                                        }}>
                                        {col.field === 'HasDiscountPolicy' ?
                                            obj.HasDiscountPolicy === 1 ? `${Number(obj.DiscountPer)}%` : `${Number(obj.DiscountAmt)}Rs`
                                            : obj?.[col.field] || ''}
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}

                    </TableBody>

                </Table>
            </TableContainer>

        </Box >
    )
}

export default TripTable